var _style, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgElectorateInsights = function SvgElectorateInsights(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    id: "electorate-insights_svg__Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 24 24"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".electorate-insights_svg__st0{fill:none;stroke:#000;stroke-linecap:round;stroke-linejoin:round}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9.5c2 0 3.6 1.6 3.6 3.6q0 0 0 0c0 1.6-2.3 4.7-3.2 5.9-.2.2-.5.3-.7.1l-.1-.1c-.9-1.2-3.2-4.3-3.2-5.9 0-2 1.6-3.6 3.6-3.6q0 0 0 0",
    className: "electorate-insights_svg__st0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3 4.1c0 .8-.6 1.4-1.4 1.4s-1.3-.6-1.3-1.4.6-1.4 1.4-1.4c.7.1 1.3.7 1.3 1.4M19.9 7.5c1.8 0 3.3 1.5 3.3 3.3q0 0 0 0c0 1.4-2 4.1-2.9 5.2-.2.2-.5.3-.7.1l-.1-.1c-.9-1.1-2.9-3.8-2.9-5.2.1-1.8 1.5-3.3 3.3-3.3q0 0 0 0",
    className: "electorate-insights_svg__st0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2 10.8c0 .7-.5 1.2-1.2 1.2s-1.2-.5-1.2-1.2.5-1.2 1.2-1.2c.6-.1 1.2.5 1.2 1.2q0 0 0 0M9 15.3c-.4 2.2-4.1 6-4.1 8.2 0-2.2-3.6-5.6-4.1-8.2-.5-2.1.8-4.2 2.9-4.7.4-.1.8-.1 1.2-.1 2.2-.2 4 1.5 4.2 3.6.1.4 0 .8-.1 1.2",
    className: "electorate-insights_svg__st0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.8 14.4c0 1-.8 1.9-1.9 1.9-1 0-1.9-.8-1.9-1.9s.8-1.9 1.9-1.9q0 0 0 0c1.1 0 1.9.9 1.9 1.9q0 0 0 0M11.9 12l4.9 3.3M7.5 22.3l9.9-4.6",
    className: "electorate-insights_svg__st0"
  })));
};
export default SvgElectorateInsights;